export const browserTabVisible = (): boolean => {
  return typeof document !== 'undefined' && !document.hidden
}

export const browserTabHidden = (): boolean => {
  return !browserTabVisible()
}
